import Transform from '@ember-data/serializer/transform';

export interface ValidityPeriod {
  startDate: string;
  endDate: string;
}

interface SerializedValidityPeriod {
  start_date: string;
  end_date: string;
}

export default class ValidityPeriodsTransform extends Transform {
  deserialize(serialized: unknown): ValidityPeriod[] {
    if (!Array.isArray(serialized)) {
      return [];
    }

    return (serialized as SerializedValidityPeriod[]).map((period) => ({
      startDate: period.start_date,
      endDate: period.end_date,
    }));
  }

  serialize(deserialized: unknown): SerializedValidityPeriod[] {
    if (!Array.isArray(deserialized)) {
      return [];
    }

    return (deserialized as ValidityPeriod[]).map((period) => ({
      start_date: period.startDate,
      end_date: period.endDate,
    }));
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    'validity-periods': ValidityPeriodsTransform;
  }
}
